/* Que Shebley — Luxe Homepage scripts */
(function(){
  var clamp = function(v,a,b){ return Math.max(a,Math.min(b,v)); };

  // ——— HAMBURGER ———
  var burger = document.getElementById('luxe-burger');
  var panel  = document.getElementById('luxe-nav-panel');
  if (burger && panel){
    burger.addEventListener('click',function(){
      burger.classList.toggle('is-open');
      panel.classList.toggle('is-open');
    });
  }

  // ——— SIGNATURE — JS-fixed pin (bypasses Prestige overflow:hidden on .shopify-section) ———
  var sigTrack  = document.getElementById('luxe-sig-track');
  var sigPin    = document.getElementById('luxe-sig-pin');
  var codeGlyph = document.getElementById('luxe-code-glyph');
  var lastSigStep = -1;
  var sigPinMode = null;
  var sigFrames = [], sigSlides = [], sigRail = [];

  if (sigTrack && sigPin){
    sigFrames = Array.prototype.slice.call(sigTrack.querySelectorAll('.luxe-sig__frame'));
    sigSlides = Array.prototype.slice.call(sigTrack.querySelectorAll('.luxe-sig__slide'));
    sigRail   = Array.prototype.slice.call(sigTrack.querySelectorAll('.luxe-sig__rail b'));
  }

  function setSigStep(i){
    if (i === lastSigStep) return;
    lastSigStep = i;
    sigFrames.forEach(function(f,idx){ f.classList[idx===i?'add':'remove']('is-on'); });
    sigSlides.forEach(function(s,idx){ s.classList[idx===i?'add':'remove']('is-on'); });
    sigRail.forEach(function(r,idx){ r.classList[idx<=i?'add':'remove']('is-on'); });
  }

  if (sigFrames.length) setSigStep(0);

  // Preload all frame images immediately so no loading lag when acts switch
  sigFrames.forEach(function(f){
    var img = f.querySelector('img');
    if (img && img.src){ var p = new Image(); p.src = img.src; }
  });

  // ——— MAIN LOOP — requestAnimationFrame runs every frame regardless of scroll container ———
  // This is the key fix: window scroll events never fire inside Prestige's inner scroll container.
  // getBoundingClientRect() always returns viewport-relative coordinates — no scroll listener needed.
  //
  // Both getBoundingClientRect() reads happen before any style writes below. Reading layout after
  // writing to style in the same frame forces the browser to do a synchronous reflow (Lighthouse
  // flagged this as "Forced reflow" against this file) — batching reads-then-writes avoids that.
  function loop(){
    var vh = window.innerHeight;
    var gc = codeGlyph ? codeGlyph.getBoundingClientRect() : null;
    var r  = (sigTrack && sigPin && sigFrames.length) ? sigTrack.getBoundingClientRect() : null;

    // Glyph parallax (philosophy section)
    if (gc){
      var gp = (vh - gc.top) / (vh + gc.height);
      codeGlyph.style.transform = 'translateX('+((gp-0.5)*-260)+'px)';
    }

    // Signature JS-fixed engine
    if (r){
      var h = r.height; // same as sigTrack.offsetHeight (300vh in px)

      if (r.top > 0){
        // User hasn't scrolled to the track yet — pin rests at top of track, in flow
        if (sigPinMode !== 'before'){
          sigPin.style.cssText = 'position:absolute;top:0;left:0;right:0;height:'+vh+'px';
          sigPinMode = 'before';
        }
        setSigStep(0);
      } else if (r.bottom <= vh){
        // User has scrolled past the track — pin rests at bottom of track, in flow
        if (sigPinMode !== 'after'){
          sigPin.style.cssText = 'position:absolute;top:auto;bottom:0;left:0;right:0;height:'+vh+'px';
          sigPinMode = 'after';
        }
        setSigStep(sigFrames.length-1);
      } else {
        // Track straddles the viewport — fix the pin so it covers the screen
        if (sigPinMode !== 'fixed'){
          sigPin.style.cssText = 'position:fixed;top:0;left:0;right:0;height:'+vh+'px;z-index:9000';
          sigPinMode = 'fixed';
        }
        // progress: 0 when track top hits viewport top, 1 when track bottom hits viewport bottom
        var progress = clamp(-r.top / (h - vh), 0, 1);
        var step = clamp(Math.floor(progress * sigFrames.length), 0, sigFrames.length-1);
        setSigStep(step);
      }
    }

    requestAnimationFrame(loop);
  }

  requestAnimationFrame(loop);

  // ——— MOBILE ACCORDION ———
  Array.prototype.forEach.call(document.querySelectorAll('[data-acc]'), function(acc) {
    var btn = acc.querySelector('.luxe-panel__acc-hd');
    var body = acc.querySelector('.luxe-panel__acc-body');
    if (!btn || !body) return;
    btn.addEventListener('click', function() {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (open) { body.setAttribute('hidden', ''); } else { body.removeAttribute('hidden'); }
    });
  });

  // ——— MOBILE FOOTER ACCORDION — collapse the link columns on phones (desktop stays expanded) ———
  // aria-expanded lives on the real <button> (accessible state); data-expanded mirrors it onto the
  // parent <h5> purely as a CSS hook, since the <ul> we show/hide is a sibling of the <h5>, not the button.
  Array.prototype.forEach.call(document.querySelectorAll('[data-foot-acc] .luxe-foot__col-btn'), function (btn) {
    var hd = btn.closest('.luxe-foot__col-hd');
    btn.addEventListener('click', function () {
      if (window.matchMedia('(min-width:761px)').matches) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (hd) hd.setAttribute('data-expanded', open ? 'false' : 'true');
    });
  });

  // ——— LUXURY EMAIL POPUP ———
  (function(){
    var COOKIE = 'luxe_popup_v1';
    var DELAY  = 5000;
    function hasCookie(){ return document.cookie.indexOf(COOKIE+'=') !== -1; }
    function setCookie(days){
      var d = new Date();
      d.setTime(d.getTime() + days * 864e5);
      document.cookie = COOKIE + '=1;expires=' + d.toUTCString() + ';path=/';
    }
    var pop = document.getElementById('luxe-popup');
    if (!pop || hasCookie()) return;
    function openPop(){
      pop.removeAttribute('hidden');
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ pop.classList.add('is-open'); }); });
    }
    function closePop(subscribed){
      pop.classList.remove('is-open');
      setTimeout(function(){ pop.setAttribute('hidden',''); }, 500);
      setCookie(subscribed ? 365 : 14);
    }
    setTimeout(openPop, DELAY);
    document.getElementById('luxe-popup-close').addEventListener('click', function(){ closePop(false); });
    document.getElementById('luxe-popup-decline').addEventListener('click', function(){ closePop(false); });
    pop.addEventListener('click', function(e){ if (e.target === pop) closePop(false); });
    document.addEventListener('keydown', function(e){ if (e.key==='Escape' && pop.classList.contains('is-open')) closePop(false); });
    var form      = document.getElementById('luxe-popup-form');
    var errEl     = document.getElementById('luxe-popup-error');
    var successEl = document.getElementById('luxe-popup-success');
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var email = document.getElementById('luxe-popup-email').value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){ errEl.removeAttribute('hidden'); return; }
      errEl.setAttribute('hidden','');
      // Subscribe to Klaviyo "SMS Subscribers" list (triggers Welcome Flow)
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=NjtTsD', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } },
              list_id: 'QQSjHk',
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
            }
          }
        })
      }).finally(function(){
        form.setAttribute('hidden','');
        successEl.removeAttribute('hidden');
        setTimeout(function(){ closePop(true); }, 3000);
      });
    });
  })();

  // ——— CART DRAWER — open Prestige's built-in drawer instead of navigating to /cart ———
  var bagBtn = document.querySelector('.luxe-nav__bag');
  if (bagBtn) {
    bagBtn.addEventListener('click', function(e) {
      var cartDrawer = document.getElementById('cart-drawer');
      if (cartDrawer && typeof cartDrawer.show === 'function') {
        e.preventDefault();
        cartDrawer.show();
      }
      // If no drawer found, link falls through to /cart as a safe fallback
    });
  }

  // ——— MADE-TO-ORDER CONFIGURATOR — let the iframe container grow to its content height ———
  // The made-to-order app reports its content height by writing it to #configurator-container's
  // inline style. A theme rule locks that container to the viewport height, which traps the tall
  // (especially mobile) sizing form in an internal scroll and makes it feel jumpy. This mirrors the
  // app's reported height as an inline !important so the WHOLE page scrolls as one — no nested scroll —
  // and adds a gap so the Add-to-Cart button doesn't blend into the footer. Does not touch the iframe.
  (function () {
    var tries = 0;
    function init() {
      var c = document.getElementById('configurator-container');
      if (!c) { if (tries++ < 24) setTimeout(init, 500); return; }
      var mo = new MutationObserver(function () { sync(); });
      function sync() {
        var h = c.style.height;
        if (!h || h === '0px' || h === 'auto') return;
        mo.disconnect();
        c.style.setProperty('height', h, 'important');
        c.style.setProperty('max-height', 'none', 'important');
        c.style.setProperty('overflow', 'visible', 'important');
        c.style.setProperty('margin-bottom', '52px', 'important');
        var f = c.querySelector('iframe');
        if (f) { f.style.setProperty('height', '100%', 'important'); f.style.setProperty('max-height', 'none', 'important'); }
        mo.observe(c, { attributes: true, attributeFilter: ['style'] });
      }
      sync();
      mo.observe(c, { attributes: true, attributeFilter: ['style'] });
    }
    init();
  })();


})();
